import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Tie } from '../../../../_shared/models/tie.model';

@Injectable({
    providedIn: 'root'
})
export class DownloadTieService {

    private downloadedTie$ = new Subject<any>();

    constructor(
        private http: HttpClient
    ) { }

    download(clubSparkTournamentId, templateSubtype, partner, timezoneOffset, seasonId, leagueId) {
        return this.http.post<any>('api_endpoint' + `/dual-match/download`, { clubSparkTournamentId, templateSubtype, partner, timezoneOffset, seasonId, leagueId });
    }

    publishDownloadedTie(tie: Tie) {
        this.downloadedTie$.next(tie);
    }

    subscribeDownloadedTie(): Observable<Tie> {
        return this.downloadedTie$.asObservable();
    }

}
